const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]

export const convertDate = input => {
    const date = new Date(input);
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();
    return day + " " + months[month].substr(0, 3) + " " + year;
}